import React from 'react';
import { Button } from '@/Components/ui/button';
import { Stack } from '@/Components/ui/layout';
import { ChevronRight } from 'lucide-react';

function TopicButton() {
  return (
    <Stack spacing="md" className="w-full">
      <Button className="w-[288px] max-w-full mt-5 capitalize font-semibold">
        Select a Topic
        <ChevronRight className="w-8 h-8 ml-2" />
      </Button>
      <div className="flex items-center justify-between w-full mt-6">
        <Button variant="ghost" className="text-muted-foreground capitalize font-semibold">
          Cancel
        </Button>
      </div>
    </Stack>
  );
}

export default TopicButton;